import PageHero from "../components/sections/PageHero";
import WhyUs from "../components/sections/WhyUs";
import Process from "../components/sections/Process";
import CTASection from "../components/sections/CTASection";
import ServiceArea from "../components/sections/ServiceArea";

const STATS = [
  ["2019", "Established"],
  ["03", "Core Services"],
  ["NCR", "Service Area"],
  ["R · C · I", "Residential · Commercial · Industrial"],
];

export default function About() {
  return (
    <>
      <PageHero
        eyebrow="About Urban Painter"
        title="A specialist team for"
        italic="flooring, waterproofing & painting."
        subtitle="Established in 2019 and based in Gurugram, Urban Painter serves residential, commercial and industrial customers across Gurugram, Manesar, Sohna and Delhi NCR."
        image="https://images.pexels.com/photos/1108101/pexels-photo-1108101.jpeg?auto=compress&cs=tinysrgb&w=2000"
      />

      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-[1200px] mx-auto px-5 md:px-8 grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <div className="font-mono text-[11px] tracking-[0.25em] uppercase text-ink-muted mb-5">
              Studio
            </div>
            <h2 className="font-display text-3xl md:text-5xl text-ink leading-tight tracking-[-0.03em]">
              Focused on three
              <br />
              <span className="font-serif-italic font-normal text-ink-mid">
                things, done well.
              </span>
            </h2>
          </div>
          <div className="md:col-span-7 space-y-5 text-ink-mid leading-relaxed text-base md:text-lg">
            <p>
              Urban Painter began as a small crew taking on painting jobs across
              Gurugram. Over the years, the scope expanded to include the two
              services most often needed alongside painting — waterproofing and
              epoxy flooring.
            </p>
            <p>
              The three services stay closely connected on site. A newly
              painted wall doesn&rsquo;t last if there is untreated seepage. A
              factory floor doesn&rsquo;t look right if the concrete
              underneath isn&rsquo;t prepared. Doing all three under one team
              keeps the work sequenced correctly.
            </p>
            <p className="text-ink-muted">
              Everything is priced transparently and inspected before
              execution.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-ink text-white py-14 md:py-20">
        <div className="max-w-[1200px] mx-auto px-5 md:px-8 grid grid-cols-2 md:grid-cols-4 gap-y-10">
          {STATS.map(([n, l]) => (
            <div key={l} className="border-l border-white/15 pl-5">
              <div className="font-display text-3xl md:text-5xl leading-none">
                {n}
              </div>
              <div className="mt-3 font-mono text-[10px] tracking-[0.25em] uppercase text-white/60">
                {l}
              </div>
            </div>
          ))}
        </div>
      </section>

      <WhyUs />
      <Process />
      <ServiceArea />
      <CTASection />
    </>
  );
}
